export const ComplianceConfigurationKeys = Object.freeze({
  SegregationOfDuties: "segregation-of-duties",
});

export const ComplianceConfigurationContentTypes = Object.freeze({
  SegregationOfDuties: "application/json+segregation-of-duties",
});
